import React from "react";
import { Base } from "../../styles";
import ButtonCard from "../ButtonCard";
import BackgroundImage from "./BackgroundImage";
import ContentGutter from "../ContentGutter";
import SeriesCTAGrid from "./SeriesCTAGrid";
const SeriesCTA = ({
  headline,
  copy,
  link,
  copySide,
  backgroundImage
}) => {
  return /* @__PURE__ */ React.createElement(Base, {
    as: "section",
    color: "white"
  }, /* @__PURE__ */ React.createElement(BackgroundImage, {
    backgroundImage,
    imageStyle: { objectPosition: "top" }
  }, /* @__PURE__ */ React.createElement(ContentGutter, null, /* @__PURE__ */ React.createElement(SeriesCTAGrid, {
    copySide
  }, /* @__PURE__ */ React.createElement(ButtonCard, {
    headline,
    copy,
    link,
    target: "_blank"
  })))));
};
export default SeriesCTA;
